import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export type IImageData = {
    imageUrl: URL | null;
    timeStamp: string;
};
export interface IDeviceState {
    [key: string]: IImageData;
}

const initialState: IDeviceState = {};

const imageCacheSlice = createSlice({
    name: 'imageCache',
    initialState,
    reducers: {
        updateImageCacheState: (state, action) => {
            const { id, imageData } = action?.payload ?? {};

            return {
                ...state,
                [id]: imageData,
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { updateImageCacheState } = imageCacheSlice.actions;

export const imageCacheReducer = imageCacheSlice.reducer;
